import React from 'react';
import { ApiSelect, TextType } from "@baseTypes/baseType";
import { PhaseState } from "../../../../store/reducers/dashboard/phases/types";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../store";
import { identity } from "fp-ts/es6/function";
import { stickerLoadingWithCrop } from "../index";
import { useTypedSelector } from "@hooks/useTypedSelector";
import Empty from './empty';
import { isEmpty } from "lodash";
import Sticker from "../../../../components/elements/sticker/Sticker";
import GrowthPhasesByMonthChart from "./chart";
import st from "../common.module.scss";
import ChartHeader from "@elements/chart/ChartHeader";
import Tx from "@baseTypes/naming";
import { formatNumber2d } from "@utils/format/number";
import FlexLine from "@elements/flexLine/FlexLine";
import Highcharts from "highcharts";

const phaseSelector: ApiSelect<PhaseState> =
	createSelector((state: RootState) => state.phases, identity<PhaseState>);

type PhasesWithPeriodProps = {
	setPhasesChartApi: React.Dispatch<React.SetStateAction<Highcharts.Chart | undefined>>
}

const PhasesWithPeriod = (props: PhasesWithPeriodProps) => {
	const { setPhasesChartApi } = props;
	const { data = [] } = useTypedSelector(phaseSelector);
	const total = data.reduce((acc, i) => acc + (i.sum || 0), 0);
	const { selected } = useTypedSelector(state => state.cropSelector);

	const renderBody = () => {
		return (
			<div className={st['content']}>
				<FlexLine textType={TextType.Header} className={st.header}>
					<ChartHeader>{Tx.StateCrops}</ChartHeader>
					<div className={st.total_label}>{formatNumber2d(total)} Га
					</div>
				</FlexLine>
				<GrowthPhasesByMonthChart stageRipeScoutingDash={data} apiCallback={setPhasesChartApi} />
			</div>
		)
	}

	return (
		<Sticker>
			{total && selected && !isEmpty(selected) ? renderBody() : <Empty/>}
		</Sticker>
	)
}

export default stickerLoadingWithCrop(
	phaseSelector,
	() => () => ''
)(PhasesWithPeriod);